// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileWordOutlinedSvg from "@fishx/icons-svg/es/asn/PFileWordOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileWordOutlined = function PFileWordOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileWordOutlinedSvg
  }));
};

PFileWordOutlined.displayName = 'PFileWordOutlined';
export default React.forwardRef(PFileWordOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileWordOutlined.js
// module id = 3412
// module chunks = 0